// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__34F2L","description":"MealItem_description__3jMOS","price":"MealItem_price__PKSrz"};